import CabeceraCuotaAnterior from '../components/CabeceraCuotaAnterior.vue';
import configuracionesMixin from './configuraciones.mixin';

export default {
  mixins: [configuracionesMixin],
  components: {
    CabeceraCuotaAnterior,
  },
  props: {
    mostrarColumnaCuotaAnterior: {
      type: Boolean,
      default: false,
    },
    detallePagoConceptoUniversidadCuotaAnterior: {
      type: [Object, null],
      default: () => null,
    },
    inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    detallePagoConceptoUniversidadCuotaAnterior: {
      handler: function () {
        this.gridApi?.refreshHeader();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    agregarColumnaEstadoCuotaAnterior(indiceColumna) {
      this.columnDefs.splice(indiceColumna, 0, {
        headerComponent: 'CabeceraCuotaAnterior',
        headerComponentParams: () => {
          return {
            nombreCampo:
              this.detallePagoConceptoUniversidadCuotaAnterior == null
                ? 'ESTADO CUOTA ANTERIOR'
                : `${this.detallePagoConceptoUniversidadCuotaAnterior.numeroCuota}° CUOTA -
                  ${this.detallePagoConceptoUniversidadCuotaAnterior.planPagoConceptoUniversidad.conceptoUniversidad.concepto.nombre}
                  (ANTERIOR)`,
          };
        },
        cellRenderer: (params) => {
          const estadoCuotaAnterior = params?.data?.estadoCuotaAnterior;

          let color = 'default';

          if (estadoCuotaAnterior === 'sin cuota anterior') {
            color = 'orange';
          } else if (estadoCuotaAnterior === 'pagada') {
            color = 'green';
          } else if (estadoCuotaAnterior === 'no pagada') {
            color = 'red';
          }

          return /*html*/ `
              <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                  <span class="v-chip__content"> ${estadoCuotaAnterior.toUpperCase()} </span>
              </span>
            `;
        },
        valueGetter: (params) => params.data.estadoCuotaAnterior,
        minWidth: 250,
        maxWidth: 250,
      });
    },
  },
};
